import React from "react";
import PropTypes from "prop-types";
import { browserHistory } from "react-router";
import { connect } from "react-redux";
import { AccountUsers } from "components/settings/account-users";
import {
  fetchAccountUsersAction,
  createUserAction,
  removeUserAction,
  setInviteUserVisibilityAction,
  setRemoveSelfVisibilityAction
} from "actions/account-settings-actions";
import { Loading } from "components/common/loading";

class AccountUsersPage extends React.Component {
  componentWillMount() {
    this.props.init(this.props.accountId);
  }

  render() {
    if (this.props.isAccountUsersLoading) {
      return <Loading />;
    }
    if (this.props.vip) {
      return browserHistory.push("/");
    }
    return (
      <AccountUsers { ...this.props } />
    );
  }
}

AccountUsersPage.propTypes = {
  accountId: PropTypes.string.isRequired,
  init: PropTypes.func.isRequired,
  isAccountUsersLoading: PropTypes.bool.isRequired,
  vip: PropTypes.bool.isRequired
};

const mapStateToProps = (state) => ({
  accountId: state.app.selectedAccount.id,
  currentUserId: state.app.user.id,
  isAccountUsersLoading: state.accountSettings.isAccountUsersLoading,
  isInviteUserVisible: state.accountSettings.isInviteUserVisible,
  isRemoveSelfVisible: state.accountSettings.isRemoveSelfVisible,
  users: state.accountSettings.users,
  vip: state.accountSettings.vip
});

const mapDispatchToProps = (dispatch) => ({
  init: (accountId) => dispatch(fetchAccountUsersAction(accountId)),
  onCreateUser: () => dispatch(createUserAction()),
  onHideInviteUser: () => dispatch(setInviteUserVisibilityAction(false)),
  onHideRemoveSelf: () => dispatch(setRemoveSelfVisibilityAction(false)),
  onRemoveUser: (accountId, user) => dispatch(removeUserAction(accountId, user)),
  onShowInviteUser: () => dispatch(setInviteUserVisibilityAction(true)),
  onShowRemoveSelf: () => dispatch(setRemoveSelfVisibilityAction(true))
});

export const AccountUsersContainer = connect(mapStateToProps, mapDispatchToProps)(AccountUsersPage);



// WEBPACK FOOTER //
// ./src/js/containers/settings/account-users-container.jsx